module.exports = __webpack_public_path__ + "media/images/btn_imgclose-083df96db6e85a9918b690c3afe5a7b7.svg";